import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box } from '@livable/saas-react-components';
import { Container, Tab, Tabs } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useURLHandler } from 'src/utils/hooks';
import LivableGuidesTab from './LivableGuidesTab';
import ManagerResourcesTab from './ManagerResourcesTab';
import { TenantAddendumsTab } from './TenantAddendumsTab';
import { UtilityBillsTab } from './UtilityBillsTab';
export const FileCabinetPage = observer(() => {
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const tabsNames = ['manager_resources', 'utility_bills', 'resident_addenda'
  // 'guides',
  ];
  const _useURLHandler = _objectSpread({}, useURLHandler('manager_resources', tabsNames)),
    handleSelectedTabChange = _useURLHandler.handleSelectedTabChange,
    selectedTab = _useURLHandler.selectedTab;
  const handleChange = (event, newValue) => handleSelectedTabChange(newValue);
  const getTab = () => {
    switch (selectedTab) {
      case 'guides':
        return /*#__PURE__*/React.createElement(LivableGuidesTab, null);
      case 'manager_resources':
        return /*#__PURE__*/React.createElement(ManagerResourcesTab, null);
      case 'resident_addenda':
        return /*#__PURE__*/React.createElement(TenantAddendumsTab, null);
      default:
      case 'utility_bills':
        return /*#__PURE__*/React.createElement(UtilityBillsTab, null);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tabs, {
    "aria-label": "tabs navigation",
    onChange: handleChange,
    position: "sticky",
    type: "navigation",
    value: selectedTab
  }, tabsNames.map(tabName => /*#__PURE__*/React.createElement(Tab, {
    label: t("file_cabinet.".concat(tabName)),
    key: tabName,
    value: tabName,
    'custom-attribute': '755-FileCabinetPage-page-' + tabName
  }))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, getTab())));
});